import {List} from 'immutable';
import {NewButton} from 'components/ui';
import {MarkerOccurrence} from 'utils/types/markers';
import styles from './IndicatorsOccurrencesTable.module.scss';

export interface IndicatorsOccurrencesTableProps {
  list?: List<ImmutableMap<MarkerOccurrence>>;
  onClickButton?(): void;
}

function IndicatorsOccurrencesTable({
  list,
  onClickButton,
}: IndicatorsOccurrencesTableProps): JSX.Element {
  return (
    <div className={styles.indicatorsOccurrencesTable}>
      <table>
        <thead>
          <tr>
            <th>Desvio</th>
            <th>Ocorrências</th>
          </tr>
        </thead>
        <tbody>
          {list?.size ? (
            list.map((student) => {
              const numberOfOccurences =
                student.get('count') < 10
                  ? `0${student.get('count')}`
                  : `${student.get('count')}`;

              return (
                <tr key={student.get('text')}>
                  <td>{student.get('text')}</td>
                  <td>
                    {student.get('count') === 1
                      ? `${numberOfOccurences} vez`
                      : `${numberOfOccurences} vezes`}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={2}>Nenhum desvio foi encontrado.</td>
            </tr>
          )}
        </tbody>
      </table>
      {onClickButton && (
        <NewButton
          text="Ver redação"
          userRole="student"
          onClick={onClickButton}
          size="small"
        />
      )}
    </div>
  );
}

export default IndicatorsOccurrencesTable;
